// extracted by mini-css-extract-plugin
module.exports = {"body1":"Text_body1__1PnQP","heading3":"Text_heading3__IKuuX"};